import { Info, Notes, AddTask, FamilyRestroom, CalendarMonth, Sms, Troubleshoot, ListAlt } from "@mui/icons-material";
import { ROLES } from "../../utils/constants";

export const tabs = [
	{
		icon: <Info />,
		entity: "detail",
		label: "Detalhes"
	},
	{
		icon: <CalendarMonth />,
		entity: "sessions",
		label: "Sessões"
	},

	{
		icon: <FamilyRestroom />,
		entity: "relatives",
		label: "Parentes"
	},
	{
		icon: <Notes />,
		entity: "notes",
		label: "Notas"
	},
	{
		icon: <AddTask />,
		entity: "tasks",
		label: "Tarefas"
	},
	{
		icon: <Sms />,
		entity: "communications",
		label: "Comunicações"
	},
	{
		icon: <Troubleshoot />,
		entity: "instruments_responses",
		label: "Instrumentos"
	},
	{
		icon: <ListAlt />,
		entity: "intake_form",
		label: "Anamnese",
		filter: (context: { item?: any; userRole?: string }) => {
			const clientType = context.item?.client_type;
			const isValidClientType = clientType === "child" || clientType === "adult";
			const isAuthorizedRole =
				context.userRole &&
				[
					ROLES.admin,
					ROLES.shilan,
					ROLES.neurofeedback_director,
					ROLES.technical_director,
					ROLES.nfb_and_theurapist,
					ROLES.theurapist,
					ROLES.tech_admin,
					ROLES.nfb_techncians,
					ROLES.substituion_joana_temp,
					ROLES.client_owner
				].includes(context.userRole);
			return isValidClientType && !!isAuthorizedRole;
		}
	}
];
